import script from "./LocationMappingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationMappingStep.vue?vue&type=script&setup=true&lang=js"

import "./LocationMappingStep.vue?vue&type=style&index=0&id=18067418&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18067418"]])

export default __exports__